<!--
  No form here any more.

  The sign-in form is served by the authorization server, so that a phone
  signing in stays on auth.reservedine.com instead of being sent to this web
  app — which is what was reported as "authentication is performed outside the
  mobile application". This route still exists because guards redirect to
  /login with a returnUrl, and because links to it are in the wild; it simply
  starts the OAuth flow and gets out of the way.
-->
<div class="auth-container">
  <mat-card class="auth-card">
    <mat-card-content>
      <div class="flex flex-col items-center justify-center gap-4 py-10">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="text-gray-600">Taking you to sign in…</p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
